import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgSwitchDouble = (props) => /* @__PURE__ */ _jsxs("svg", {
	width: 45,
	height: 19,
	viewBox: "0 0 45 19",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: [/* @__PURE__ */ _jsx("path", {
		d: "M44.2658 2.73572H28.8111L16.7908 16.7531H0.477539",
		stroke: "currentColor",
		strokeWidth: 4
	}), /* @__PURE__ */ _jsx("path", {
		d: "M0.477337 2.00513H15.9321L27.9523 16.0225H44.2656",
		stroke: "currentColor",
		strokeWidth: 4
	})]
});
export default SvgSwitchDouble;
